module.exports = __webpack_public_path__ + "img/factsheet_footer_background.cec09aa9.png";